var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "alerts-nav" },
    [
      _c("tab", {
        attrs: {
          handleClick: _vm.setLeft,
          text: "Current",
          "data-selected": _vm.left
        }
      }),
      _vm._v(" "),
      _c("tab", {
        attrs: {
          handleClick: _vm.setRight,
          text: "Past",
          "data-selected": !_vm.left,
          "data-right": ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22509a55", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22509a55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/nav/AlertsNav.vue
// module id = null
// module chunks = 